import { Component, OnInit } from '@angular/core';
import { HamburgerMenuComponent } from "../../shared/components/hamburger-menu/hamburger-menu.component";
import { Router } from '@angular/router';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
  standalone: true,
  imports: [
    HamburgerMenuComponent
  ]
})
export class HomeComponent implements OnInit {
bloqueEnCursoAsistencia: any = true;
user: any = {
  trab_nombres: 'Andres',
  trab_apellido_paterno: 'Perez',
  trab_apellido_materno: 'Perez'
};
nombreAcca: any = 'Prevención de Riesgos en faena minera nivel 2';
accaId: any;

  constructor(
    private readonly _router: Router,
  ) { }
  
  ngOnInit() {
  }
  
  goConfiguracion() {
    this._router.navigate(['/listado-empresas']);
  }

  goSeguimiento() {
    this._router.navigate(['/listado-ac-ejecucion']);
  }

  goReportes() {
    this._router.navigate(['/listado-ac']);
  }

  goTomarAsistencia(arg0: any,arg1: boolean) {
  }
}
